import React, { useEffect, useMemo, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { Autoplay, FreeMode, Navigation, Thumbs } from "swiper/modules";
import { getShippingOpt, orderCreate } from "actions/dropshippingActions";
import useCallApi from "hook/useCallApi";
import _ from "lodash";
import { ReactComponent as ChevronSVG } from "components/assets/vendors/images/chevron.svg";
import { orderRate } from "actions/dropshippingActions";
import Loading from "components/Loading";

const ProductDropDetail = ({ isOpen, onClose, product, getShippingOpt, source, orderRate, orderCreate }) => {
    const [select, setSelect] = useState(0);
    const [numberItems, setNumberItems] = useState(1);
    const [zipShip, setZipShip] = useState("90006");
    const [dataShip, setDataShip] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const params = useMemo(() => {
        return { sku: product?.variants?.[select]?.sku, source };
    }, [select, product]);
    const { data: shipDetail } = useCallApi(getShippingOpt, params);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const swiperRefer = useRef(null);

    const goNext = () => {
        if (swiperRefer.current) {
            swiperRefer.current.swiper.slideNext();
        }
    };

    const goPrev = () => {
        if (swiperRefer.current) {
            swiperRefer.current.swiper.slidePrev();
        }
    };

    const [minPrice, maxPrice] = useMemo(() => {
        if (!product?.variants) return [0, 0];
        const minItem = product?.sell_price || _.minBy(product?.variants, "sell_price")?.sell_price;
        const maxItem = product?.sell_price || _.maxBy(product?.variants, "sell_price")?.sell_price;
        return [minItem, maxItem];
    }, [product?.variants]);

    useEffect(() => {
        if (!isOpen) {
            setSelect(0);
            setThumbsSwiper(null);
            setDataShip([]);
        }
    }, [isOpen]);


    const handleOrderRate = async () => {
        if (product?.sku && product?.store_id) {
            setIsLoading(true);
            setDataShip([]);
            await orderRate({
                "store_id": +product?.store_id,
                "zip": zipShip,
                "goods": [
                    {
                        "num": +numberItems,
                        "sku": product?.product_sn,
                    }
                ]
            }).then((data) => {
                if (Array.isArray(data) && data?.length > 0) {
                    setDataShip(data);
                }
                setIsLoading(false);
            });
        }

    };

    const submitFulfillment = async (shipData) => {
        if (product?.sku && product?.store_id && shipData?.shipped_id && +zipShip > 0 && +numberItems > 0) {
            setIsLoading(true);
            // setDataShip([]);
            await orderCreate({
                shipData,
                "store_id": +product?.store_id,
                "zip": zipShip,
                "goods": [
                    {
                        "num": +numberItems,
                        "sku": product?.product_sn,
                    }
                ]
            }).then((data) => {
                setIsLoading(false);
            });
        }
    };

    return (
        <Modal
            centered={true}
            size="xl"
            toggle={() => {
                onClose();
            }}
            isOpen={isOpen}
            scrollable
        >
            <div className="modal-header">
                <h1 className="mb-0 text-dark">Product Detail</h1>
                <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                    <i
                        className="ki-outline ki-cross fs-1"
                        onClick={() => {
                            onClose();
                        }}
                    ></i>
                </div>
            </div>
            <ModalBody>

                <Loading isLoading={isLoading} />
                <div className="product_drop_detail container border p-8 rounded shadow-sm">
                    <div className="row">
                        <div className="col-md-5 text-center">
                            <div className="carousel slide">
                                <div className="container px-0">
                                    <Swiper
                                        spaceBetween={1000}
                                        autoplay={{
                                            delay: 4500,
                                            disableOnInteraction: true,
                                        }}
                                        thumbs={{ swiper: thumbsSwiper }}
                                        pagination={{ type: "fraction" }}
                                        modules={[FreeMode, Navigation, Thumbs, Autoplay]}
                                        ref={swiperRefer}
                                        className="mySwiper2 swiper swiper-preview swiper-preview-details aspect-ratio-1"
                                    >
                                        {product?.images?.map((item, index) => (
                                            <SwiperSlide
                                                className="d-flex justify-content-center align-items-center"
                                                key={index}
                                            >
                                                <img className="img-fluid" src={item.image_url} alt={index} style={{ width: "400px", height: "400px" }} />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                    <button
                                        type="button"
                                        className="carousel-control-prev border-0 btn-carousel-action"
                                        style={{ background: "transparent" }}
                                        data-slide="prev"
                                        onClick={goPrev}
                                    >
                                        <ChevronSVG width={40} height={40} style={{ transform: "rotate(-90deg)" }} />
                                    </button>
                                    <button
                                        className="carousel-control-next border-0 btn-carousel-action"
                                        style={{ background: "transparent" }}
                                        data-slide="next"
                                        onClick={goNext}
                                    >
                                        <ChevronSVG width={40} height={40} style={{ transform: "rotate(90deg)" }} />
                                    </button>
                                </div>
                            </div>
                            <div className="container mt-2 mb-2 px-0 slider-link">
                                <Swiper
                                    onSwiper={setThumbsSwiper}
                                    autoplay={{
                                        delay: 4500,
                                        disableOnInteraction: true,
                                    }}
                                    spaceBetween={10}
                                    slidesPerView={4}
                                    freeMode={true}
                                    watchSlidesProgress={true}
                                    modules={[FreeMode, Navigation, Thumbs, Autoplay]}
                                    className="mySwiper swiper swiper-view mt-1"
                                >
                                    {product?.images?.map((item, index) => (
                                        <SwiperSlide className="h-auto" key={index}>
                                            <div
                                                className="container text-center p-1 d-flex justify-content-center align-items-center rounded-3 h-100"
                                                style={{
                                                    border: "1px solid #dee2e6",
                                                    borderRadius: "10px",
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.border = "1px solid black")}
                                                onMouseLeave={(e) =>
                                                    (e.currentTarget.style.border = "1px solid #dee2e6")
                                                }
                                            >
                                                <img
                                                    className="rounded"
                                                    src={item.image_url}
                                                    alt={index}
                                                    style={{
                                                        width: "80px",
                                                        height: "auto",
                                                        aspectRatio: "1 / 1",
                                                        objectFit: "contain",
                                                    }}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>

                        <div className="col-md-7">
                            <h5>{product?.title}</h5>
                            <p className="mb-1">
                                <b>Price Ranger</b>: ${minPrice.toFixed(2)} - ${maxPrice.toFixed(2)}
                            </p>
                            <p>${product?.sell_price || product?.variants?.[select]?.sell_price.toFixed(2)}</p>
                            {shipDetail?.[0] && (
                                <p className="shipping-cost mb-4">
                                    Estimated shipping cost({shipDetail?.[0]?.USPS}): ${shipDetail?.[0]?.price} ($
                                    {shipDetail?.[0]?.estimated_delivery_days} days)
                                </p>
                            )}

                            <ul className="list-unstyled mb-4">
                                <li>
                                    <strong>Category:</strong> {product?.category_name}
                                </li>
                                <li>
                                    <strong>ID:</strong> {product?.variants?.[select]?.sku || product?.sku}
                                </li>
                                <li>
                                    <strong>Inventory:</strong> {product?.stock_quantity}
                                </li>
                            </ul>

                            <div className="option mb-8">
                                <label className="form-label fw-bold">Options</label>

                                <div className="fr-choose-variant fs-15 fw-semibold mb-2 d-flex gap-4 flex-wrap">
                                    {product?.variants?.map((v, k) => (
                                        <button
                                            type="button"
                                            className={`btn btn-secondary ${select === k ? "active" : ""}`}
                                            data-container="body"
                                            data-toggle="popover"
                                            data-placement="top"
                                            onClick={() => setSelect(k)}
                                            key={v.variant_id}
                                        >
                                            {v.key}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className="mt-3 d-flex gap-2 mb-5">
                                <div>
                                    <label className="form-label">Buy</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={numberItems}
                                        name="numberItems"
                                        onChange={(e) => {
                                            setNumberItems(e?.target?.value);
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className="form-label">To Zipcode or Order ID:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={zipShip}
                                        name="zipShip"
                                        onChange={(e) => {
                                            setZipShip(e?.target?.value);
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className="form-label">&nbsp;</label>
                                    <button className="btn btn-dark form-control" onClick={() => {
                                        handleOrderRate();
                                    }}>Rate Ship</button>
                                </div>
                            </div>
                            <label className="form-label fw-bold">Shipping Available</label>
                            <div className="mt-3 d-flex gap-3 flex-wrap">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">Carrier</th>
                                            <th scope="col">Fee</th>
                                            <th scope="col">Estimated delivery</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dataShip?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item?.shipped_name}</td>
                                                <td>${item?.shipped_fee}</td>
                                                <td>{item?.remark}</td>
                                                <td><span className="btn btn-sm btn-primary" onClick={() => {
                                                    submitFulfillment({ shipped_id: item?.shipped_id, shipped_name: item?.shipped_name });
                                                }}>Fulfill</span> </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div className="mt-4">
                        <h6>📝 Descriptions</h6>
                        <div
                            className="description-box"
                            dangerouslySetInnerHTML={{ __html: product?.description }}
                        ></div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <button
                    type="reset"
                    id="kt_modal_users_search_reset"
                    data-bs-dismiss="modal"
                    className="btn btn-active-light me-3"
                    onClick={() => {
                        onClose();
                    }}
                >
                    Cancel
                </button>
            </ModalFooter>
        </Modal>
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
    getShippingOpt,
    orderRate,
    orderCreate,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDropDetail);
